import baseService from "../BaseService";
import mixinsMessage from "@/mixins/message";
import ItinerarioFormativo from "@/model/itinerario/ItinerarioFormativo";
import ResultadoPesquisa from "@/model/comum/ResultadoPesquisa";

export default {
  listarTodos(itinerarioFormativo, numeroPagina, qtdTotal) {
    return baseService
      .get("/api/itinerarios", {
        params: {
          idCurso: itinerarioFormativo ? itinerarioFormativo.idCurso : null,
          pagina: numeroPagina ? numeroPagina : null,
          total: qtdTotal ? qtdTotal : null
        }
      })
      .then(response => {
        if (response && response.data) {
          return new ResultadoPesquisa(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar listar Itinerários Formativos");
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  editar(id) {
    return baseService
      .get("/api/itinerarios/" + id)
      .then(response => {
        if (response && response.data) {
          return new ItinerarioFormativo(response.data);
        }
        return null;
      })
      .catch(function(error) {
        mixinsMessage.methods.error("Erro ao tentar editar Itinerário Formativo");
        // eslint-disable-next-line no-console
        console.error(error);
      });
  },
  salvar(itinerarioFormativo) {
    if (itinerarioFormativo.id) {
      return baseService
        .put("/api/itinerarios/" + itinerarioFormativo.id, itinerarioFormativo)
        .then(response => {
          mixinsMessage.methods.success(response.data);
          return response.data;
        })
        .catch(function(error) {
          mixinsMessage.methods.error(
            "Erro ao tentar atualizar Itinerário Formativo",
            error
          );
          // eslint-disable-next-line no-console
          console.error(error);
        });
    } else {
      return baseService
        .post("/api/itinerarios", itinerarioFormativo)
        .then(response => {
          mixinsMessage.methods.success(response.data);
          return response.data;
        })
        .catch(function(error) {
          mixinsMessage.methods.error("Erro ao tentar cadastrar Itinerário Formativo");
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
  },
  excluir(disciplina) {
    return baseService
      .delete("/api/itinerarios/" + disciplina.id)
      .then(response => {
        mixinsMessage.methods.success(response.data);
        return response.data;
      })
      .catch(function(error) {
        console.log(error);
        mixinsMessage.methods.error("Erro ao tentar excluir Itinerário Formativo", error);
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }
};
